<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Adicionar procedimento"
        >

            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input-autocomplete
                            :repository="repositories.procedimento"
                            :request-query-string-params="autocompletesRequestParams.procedimento.queryString"
                            :search-fields="fields.autocompletes.procedimento"
                            :text-field="p => `${this.formatProcedimento(p.codigo)} - ${p.nome}`"
                            :validations="validations.procedimento"
                            name="Procedimento"
                            v-model="model.procedimento"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.searchByApelido">
                                        <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                        <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="save"
                    color="primary"
                >
                    {{ index == null ? 'Incluir' : 'Alterar' }}
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

//Enums
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        autocompletesRequestParams() {

            const cid1 = this.data.model.atendimento && this.data.model.atendimento.cid1
                ? this.data.model.atendimento.cid1.id : null

            const cid2 = this.data.model.atendimento && this.data.model.atendimento.cid2
                ? this.data.model.atendimento.cid2.id : null

            const ciapCid1 = this.data.model.atendimento && this.data.model.atendimento.ciap1
                ? this.data.model.atendimento.ciap1.cidId : null

            const ciapCid2 = this.data.model.atendimento && this.data.model.atendimento.ciap2
                ? this.data.model.atendimento.ciap2.cidId : null

            let cidId = cid1 ? cid1 : ''

            if (cidId == '') {
                cidId = cid2 ? cid2 : cidId
            } else {
                cidId = cid2 ? (`${cidId}, ${cid2}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid1 ? ciapCid1 : cidId
            } else {
                cidId = ciapCid1 ? (`${cidId}, ${ciapCid1}`) : cidId
            }

            if (cidId == '') {
                cidId = ciapCid2 ? ciapCid2 : cidId
            } else {
                cidId = ciapCid2 ? (`${cidId}, ${ciapCid2}`) : cidId
            }

            return {
                procedimento: {
                    queryString: {
                        search_by_apelido: this.model.searchByApelido,
                        paciente_id: this.data.model.cidadao ? this.data.model.cidadao.pacienteId : null,
                        cbo: this.data.model.cadastro ? this.data.model.cadastro.ocupacaoId : null,
                        competencia: this.competencia,
                        cid_id: cidId
                    }
                }
            }
        },
        competencia() {

            if (this.data.model.cadastro && this.data.model.cadastro.dataUsuarioResponsavel) {

                return moment(this.data.model.cadastro.dataUsuarioResponsavel).format('YYYYMM')
            }

            return ''
        },
        fields() {

            return {
                autocompletes: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                }
            }
        },
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }

    },
    data: () => ({
        model: {
            procedimento: null,
            searchByApelido: false,
        },
        index: null,
        enums: {
            tipoAtendimento,
            procedimento,
        }
    }),
    methods: {
        open() {

            this.model.procedimento = null

            this.$refs.RkmModal.show()
        },
        save() {

            const procedimento = this.data.model.procedimentos.find(procedimento => procedimento.id == this.model.procedimento.id)

            if (procedimento) {

                this.showAlert('O procedimento já foi cadastrado anteriormente na ficha.', "Atenção")
                return false
            }

            const limite = this.data.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO
                ? this.data.model.procedimentos.length + 1 : this.data.model.procedimentos.length

            if (limite >= 20) {
                this.showAlert('Foi atingido o limite de 20 procedimentos por ficha.', "Atenção")
                return false
            }

            if (this.model.procedimento.codigo == this.enums.procedimento.ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA
                && this.data.model.atendimento.tipoAtendimentoId != this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO) {

                    this.showAlert("Para escuta inicial, selecione o tipo de atendimento 'Escuta inicial / Orientação'.", "Atenção")
                    return false
            }

            if (this.model.procedimento.codigo == this.enums.procedimento.ESCUTA_INICIAL_ORIENTACAO_ACOLHIMENTO_A_DEMANDA_ESPONTANEA
                && this.data.model.atendimento.tipoAtendimentoId == this.enums.tipoAtendimento.ESCUTA_INICIAL_ORIENTACAO) {

                    this.showAlert("Este procedimento é inserido automaticamente com o tipo de atendimento 'Escuta inicial / Orientação'.", "Atenção")
                    return false
            }

            if (this.model.procedimento.codigo == this.enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_CITOPATOLOGICO_DE_COLO_DE_UTERO
                && !this.data.model.condicao.cadastroIndividualId) {

                    this.showAlert("O cadastro individual do paciente se encontra incompleto, sendo essencial realizar uma atualização para aprimorar os indicadores de qualificação.", "Atenção")
                    return false
            }

            const param = {
                id: this.model.procedimento.id,
                nome: this.model.procedimento.nome,
                codigo: this.model.procedimento.codigo,
                origem: 'atencaoBasica',
                quantidade: 1,
                quantidadeMaximaExecucao: this.model.procedimento.quantidadeMaximaExecucao
            }

            if (this.index !== null) {

                this.$set(this.data.model.procedimentos, this.index, this.clone(param))
            } else {

                this.data.model.procedimentos.push(this.clone(param))
            }

            this.resetForm()

            this.$refs.RkmModal.hide()
        },
        resetForm() {

            this.model.procedimento = null
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: true },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>